export const FETCH_GUIDES_ASYNC = 'FETCH_GUIDES_ASYNC';
export const FETCH_GUIDES_END_COMPLETE = 'FETCH_GUIDES_END_COMPLETE';
export const FETCH_GUIDES_ASYNC_END = 'FETCH_GUIDES_ASYNC_END';
